
export default {
  name: "SvgSpirit",
  props: {
    color: {
      type: String,
      default: null,
    },
  },
  data () {
    return {
      // Used to scope id's to only this svg instance on the page
      id: null,
    }
  },
  computed: {
    hexColor() {
      return this.$color.getHex(this.color) || 'currentColor'
    },
  },
  mounted () {
    this.id = this._uid
  },
}
